(() => {
  class ReviewStarDeeplink {
    constructor() {
      document.querySelectorAll('.rating__caption-linked').forEach(element => {
        element.addEventListener('click', () => {
          if (window.innerWidth < 1000) { // is mobile
            let currentReviewTarget = document.getElementById(`product-${element.dataset.productId}-reviews-pocket`);
            if (currentReviewTarget.getAttribute('aria-expanded') == 'false') {
              currentReviewTarget.click();
            }
            window.scrollTo({
              top: currentReviewTarget.offsetTop - document.getElementById('shopify-section-header').offsetHeight,
              behavior: 'smooth'
            })
          } else { // is desktop
            document.getElementById(`product-${element.dataset.productId}-reviews-desktop`).click();
            window.scrollTo({
              top: document.querySelector('.shopify-section--main-product').offsetHeight + document.getElementById('shopify-section-header').offsetHeight - document.querySelector('tabs-nav').offsetHeight - 20,
              behavior: 'smooth'
            })
          }
        })
      });
    }
  }
  new ReviewStarDeeplink();
})();